/**
 * Phase 45 Plan 45-05 — Needs-attention rail (top 3).
 *
 * Source: UI-SPEC §Surface 1 Needs-attention rail. Server returns up to 6
 * items (D-05); UI shows top 3 (per UI-SPEC §Specific Ideas + RESEARCH).
 *
 * Eyebrow uses TOTAL length count (not the rendered count of 3) so the user
 * sees "Needs attention · 6" even when only 3 cards are on screen.
 * "View all" routes to `/manager/overview?attention=true` (RESEARCH Open Q3
 * recommendation; chip is no-op in v7.0 — link is the placeholder surface).
 */
import { Link } from 'react-router-dom';
import { AttentionCard } from './AttentionCard';
import type { PortfolioRow } from '../../services/api/portfolio';

export interface NeedsAttentionRailProps {
  items: PortfolioRow[];
}

export function NeedsAttentionRail({ items }: NeedsAttentionRailProps) {
  if (!items || items.length === 0) return null;
  const visible = items.slice(0, 3);
  return (
    <section aria-labelledby="needs-attention-eyebrow" className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <div
          id="needs-attention-eyebrow"
          className="text-[10px] uppercase tracking-wider text-ms-text-muted font-medium"
        >
          Needs attention · <span className="tabular-nums">{items.length}</span>
        </div>
        <Link
          to="/manager/overview?attention=true"
          className="text-[11px] text-ms-orange font-medium hover:underline focus:outline-none focus:ring-2 focus:ring-ms-orange/40 rounded-sm"
        >
          View all
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-3">
        {visible.map((row) => (
          <AttentionCard key={row.id} row={row} />
        ))}
      </div>
    </section>
  );
}
